import React from 'react'
import { Link } from '@inertiajs/react'
import styles from './LinkButton.module.scss'

type Variant = 'primary' | 'ghost' | 'link'
type Size = 'xs' | 'sm' | 'md'

interface LinkButtonProps {
  href: string
  children: React.ReactNode
  variant?: Variant
  size?: Size
  method?: 'get' | 'post' | 'put' | 'patch' | 'delete'
  as?: 'a' | 'button'
  className?: never
}

const variantMap: Record<Variant, string> = {
  primary: styles.primary, ghost: styles.ghost, link: styles.link,
}

const sizeMap: Record<Size, string> = { xs: styles.xs, sm: styles.sm, md: styles.md }

export const LinkButton: React.FC<LinkButtonProps> = ({
  href, children, variant = 'primary', size = 'md', method, as,
}) => (
  <Link
    href={href}
    method={method}
    as={as}
    className={[styles.button, variantMap[variant], variant !== 'link' ? sizeMap[size] : ''].filter(Boolean).join(' ')}
  >
    {children}
  </Link>
)
